import { Dtos, SuretyAccountId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { financialPeriodsQueryKey } from "./financials.keys";

export const useFetchFinancialPeriods = (accountId: SuretyAccountId) => {
	const { get } = useRequest();
	const { user } = useAuthenticatedUser();

	const isAdmin = user.type === "admin";

	const { data, error, isFetching, isLoading, refetch } = useQuery({
		queryKey: financialPeriodsQueryKey(accountId),
		queryFn: async () =>
			await get<Dtos.Admin.FinancialPeriod.Get.Response[]>(
				`/v2/${isAdmin ? "admin/" : ""}surety/accounts/${accountId}/financial-periods`,
			),
	});

	return {
		financialPeriods: data,
		financialPeriodsError: error,
		financialPeriodsIsFetching: isFetching,
		financialPeriodsLoading: isLoading,
		refetchFinancialPeriods: refetch,
	};
};
